import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(() => ({
  totalLabel: { marginBottom: '16px' },
}));
